'use client'
import { ContainerCustom } from '@/components'
import { INTERNAL_DATA } from '@/config/global-config'
import { COMMON_SPACING_SECTION } from '@/constants'
import { Box, Typography } from '@mui/material'
import Image from 'next/image'
import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

type TBannerContent = {
  des_1: string
  des_2: string
}
export const Banner = ({ content }: { content: TBannerContent }) => {
  const bannerRef = useRef<any>(null)
  const logoRef = useRef<any>(null)
  const textRefs = useRef<any[]>([])

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(bannerRef.current, {
        opacity: 0,
        y: 50,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: bannerRef.current,
          start: 'top 85%',
        },
      })

      gsap.fromTo(
        logoRef.current,
        { scale: 0.8, rotateZ: -10, opacity: 0 },
        {
          scale: 1,
          rotateZ: 0,
          opacity: 1,
          duration: 1,
          ease: 'back.out(1.7)',
          delay: 0.2,
          scrollTrigger: {
            trigger: bannerRef.current,
            start: 'top 80%',
          },
        }
      )

      gsap.from(textRefs.current, {
        opacity: 0,
        y: 40,
        duration: 0.8,
        ease: 'power2.out',
        stagger: 0.3,
        delay: 0.5,
        scrollTrigger: {
          trigger: bannerRef.current,
          start: 'top 80%',
        },
      })
    }, bannerRef)

    return () => ctx.revert()
  }, [])

  return (
    <Box
      ref={bannerRef}
      sx={{
        py: COMMON_SPACING_SECTION,
      }}
    >
      <ContainerCustom>
        <Box
          sx={{ textAlign: 'center' }}
          fontSize={{
            xs: '2.1vw',
            md: '1.6vw',
            lg: '1em',
          }}
        >
          <Typography
            component={'span'}
            sx={{
              color: 'inherit',
              fontSize: '7.5em',
              display: 'inline-block',
              lineHeight: '1.4',
              fontWeight: 600,
              textTransform: 'uppercase',
            }}
          >
            <span className="align-middle leading-[1.1]">VỀ</span>{' '}
            <Image
              alt="Logo"
              ref={logoRef}
              src={INTERNAL_DATA.logo}
              width={200}
              height={200}
              style={{
                objectFit: 'contain',
                display: 'inline-block',
                width: '2em',
                verticalAlign: 'middle',
              }}
            />
          </Typography>

          <Box sx={{ maxWidth: '49.2em', mx: 'auto' }}>
            <Typography
              ref={(el: HTMLSpanElement | null) => {
                textRefs.current[0] = el
              }}
              sx={{
                fontSize: '1.5em',
                fontWeight: 600,
              }}
            >
              {content?.des_1}
            </Typography>

            <Typography
              ref={(el: HTMLSpanElement | null) => {
                textRefs.current[1] = el
              }}
              mt={{ xs: 2, sm: 4 }}
              sx={{
                fontSize: '1.5em',
                fontWeight: 600,
              }}
            >
              {content?.des_2}
            </Typography>
          </Box>
        </Box>
      </ContainerCustom>
    </Box>
  )
}
